import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";

import { GridList, CompanyIdentityModal, Chip } from "components";
import { SUPPORT_TEXT } from "Views/Common/enum";
import { formatPhoneNumber } from "Shared/Utils";
import SectionWrapper from "components/SectionWrapper/SectionWrapper";

const Details = (props) => {
  const { name, data, onUpdate, countryConfig } = props;

  const {
    level_data = {},
    settings = {},
    account = {},
  } = data || {};

  const {
    company: {
      tax_id_provided = false
    } = {}
  } = account;

  const [isOpen, setIsOpen] = useState(false);

  const values = [
    {
      title: `${name} Name`,
      value: level_data?.name,
    },
    {
      title: "Display Name",
      value: level_data?.location_display_name,
      isHidden: name !== 'Location',
    },
    {
      title: "Region",
      value: level_data?.regionName,
      isHidden: name !== 'Location',
    },
    {
      title: "Legal Name",
      value: level_data?.legal_name,
    },
    {
      title: "Billing NPI",
      value: level_data?.billing_npi,
      isHidden: name !== 'Location' || countryConfig?.code !== 'US',
    },
    {
      title: "Clearinghouse Facility ID",
      value: level_data?.ext_facility_id,
      isHidden: name !== 'Location' || countryConfig?.code !== 'US',
    },
    {
      title: "Website",
      value: level_data?.plan_website,
    },
    {
      title: "Email",
      value: level_data?.email,
      info: SUPPORT_TEXT?.email,
    },
    {
      title: "Patient Website",
      value: level_data?.patient_website,
      isHidden: name !== 'Group',
    },
    {
      title: "Domain Prefix",
      value: level_data?.patient_url_part,
      isHidden: name !== 'Group',
      info: SUPPORT_TEXT?.patient_url_part,
    },
    {
      title: "Phone Number",
      value: formatPhoneNumber(level_data?.phone, countryConfig),
      info: SUPPORT_TEXT?.phone,
    },
    {
      title: "Address",
      value: level_data?.display_address,
    },
    {
      title: "Industry",
      value: level_data?.industry,
      isHidden: ["Location", "Region"].includes(name),
    },
    {
      title: "Latitude",
      value: level_data?.latitude,
      isHidden: name !== 'Location',
    },
    {
      title: "Longitude",
      value: level_data?.longitude,
      isHidden: name !== 'Location',
    },
    {
      title: "Group Status",
      value: <Chip label={level_data?.status} status={level_data?.status} />,
      isHidden: name !== 'Group',
    },
    {
      title: "EIN Number",
      value: tax_id_provided ? "Provided" : "Not Provided",
      isHidden: countryConfig?.code !== 'US',
    },
    {
      title: "Savings Summary Description",
      value: settings?.fee_schedule_desc,
      isHidden: !["Group", "Location"].includes(name),
      info: SUPPORT_TEXT?.fee_schedule_desc
    },
    {
      title: "Plan Summary Description",
      value: settings?.plan_summary_desc,
      isHidden: name !== 'Group',
      info: SUPPORT_TEXT?.plan_summary_desc
    },
    {
      title: "Location Status",
      value: <Chip label={level_data?.status} status={level_data?.status} />,
      isHidden: name !== 'Location',
    },
    {
      title: `${name} Slug`,
      value: level_data?.slug,
      isHidden: !["Location", "Region"].includes(name),
    },
  ];

  return (
    <SectionWrapper
      title={`${name} Details`}
      rightSection={
        <Button
          size="large"
          color="secondary"
          onClick={() => setIsOpen(true)}
          data-testid={`edit-${name}-details`}
        >
          Edit
        </Button>
      }
    >
      <GridList values={values} />

      {
        isOpen && (
          <CompanyIdentityModal
            data={data}
            isOpen={isOpen}
            closePopup={() => setIsOpen(false)}
            onUpdate={onUpdate}
            countryConfig={countryConfig}
          />
        )
      }
    </SectionWrapper>
  );
};

Details.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.object,
  onUpdate: PropTypes.func,
  countryConfig: PropTypes.object,
}

export default Details;
